import { MenuItem } from "@mui/material";
import { GKButton, GKSelect, Grid2, IconButton } from "components";
import { ResetIcon } from "components/Icons";

interface OnboardingSortingProps {
  setSortType: any;
  sortType: any;
}

const OnboardingSorting = (props: OnboardingSortingProps) => {
  const { setSortType, sortType } = props;

  const handleReset = () => {
    setSortType({
      sortBy: "clientName",
      order: "asc",
      filter: "",
    });
  };

  return (
    <Grid2 container alignItems="center" spacing={1}>
      <Grid2 size={6}>
        <GKSelect
          size="small"
          value={sortType.sortBy}
          onChange={(e: any) =>
            setSortType({ ...sortType, sortBy: e.target.value })
          }
        >
          <MenuItem value="clientName">Name</MenuItem>
          <MenuItem value="createdOn">Date</MenuItem>
        </GKSelect>
      </Grid2>

      <Grid2 size={5}>
        <GKSelect
          size="small"
          value={sortType.order}
          onChange={(e: any) =>
            setSortType({ ...sortType, order: e.target.value })
          }
        >
          <MenuItem value="asc">ASC → DSC</MenuItem>
          <MenuItem value="desc">DSC → ASC</MenuItem>
        </GKSelect>
      </Grid2>
      <Grid2 size={1} container justifyContent="flex-end">
        <IconButton size="small" onClick={handleReset}>
          <ResetIcon />
        </IconButton>
      </Grid2>
      <Grid2 display={"flex"} alignItems={"center"} gap={1} size={12}>
        {[
          { text: "All", value: "" },
          { text: "Pending", value: "pending" },
          { text: "Completed", value: "completed" },
        ].map((dateItem) => (
          <GKButton
            size="small"
            color={sortType.filter === dateItem.value ? "primary" : "dark"}
            fullWidth
            key={dateItem.value}
            variant={
              sortType.filter === dateItem.value ? "contained" : "outlined"
            }
            onClick={() => setSortType({ ...sortType, filter: dateItem.value })}
          >
            {dateItem.text}
          </GKButton>
        ))}
      </Grid2>
    </Grid2>
  );
};

export default OnboardingSorting;
